import styled from 'styled-components'

const Separator = styled.div`

  width: 1px;
  background: #eaeaea;
  height: ${({ height }) => height};
  margin: 0px 10px;
  &.tiny { margin: 0 5px; background-color: transparent}
`

export default Separator
